import { pickBy } from 'lodash'

import { CUSTOM_EVENT_SURVEY_TRIGGER } from '@/config/events'
import { ApplicationHelper } from '@/helpers/Application'
import { CollectiveUtil } from '@/utils/Collective'
import { DistributionUtil } from '@/utils/Distribution'
import { SURVEY_TOUCHPOINT_SUBMIT } from '@/config/constants'

export const SurveyHelper = {
  triggerSubmittedSurvey(basket) {
    // FLEX-203 no survey for collective
    if (!CollectiveUtil.isCollective(basket)) {
      // only send vepaNr if non default
      const basketHasPartner = DistributionUtil.hasPartner(basket)

      const payload = pickBy(
        {
          language: basket.language,
          touchPoint: SURVEY_TOUCHPOINT_SUBMIT,
          basketId: basket.basketId,
          vepaNr: basketHasPartner ? DistributionUtil.getDistributionPartnerByBasket(basket) : undefined,
        },
        x => !!x
      )
      SurveyHelper.triggerSurvey(payload)
    }
  },

  triggerSurvey(payload) {
    ApplicationHelper.dispatchCustomEvent(CUSTOM_EVENT_SURVEY_TRIGGER, payload)
  },
}
